import React, { FC } from 'react';

import { formatAccountNumber, formatCardNumber } from '@eika-infrastruktur/format';
import { ListPanel } from '@eika/link-panel';

import type { Card } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { accessibileAccountNumber, accessibleCurrency } from '../../services/accessibilityService';
import { currencyFormatter } from '../shared/numberFormat';

interface Props {
    card: Card;
}

const CreditCardsListItem: FC<Props> = ({ card }): JSX.Element => {
    const translated = useTranslation();
    const alias = card.name ?? translated.creditCard;

    return (
        <ListPanel
            className="account-list__element"
            key={card.number.value}
            url={card.transactionsLink}
            title={alias}
            textOne={currencyFormatter(Math.ceil(card.creditLimit), 'NOK', 0)}
            textTwo={formatCardNumber(card.number.value)}
            as="li"
            ariaLabel={`${alias}, ${accessibleCurrency(
                card.creditLimit,
                'NOK',
                0,
            )}, på kort ${accessibileAccountNumber(formatAccountNumber(card.number))}`}
        />
    );
};

export default CreditCardsListItem;
